import React, { useEffect } from "react";
import { Form, Input, Button, Card } from "antd";
import xIcon from "../../images/xClose.svg";
import { editCandidate } from "api/candidate.api";
import { creditsRefreshChanger } from "store/slices/refresh.slice";
import { useDispatch } from "react-redux";

interface CandidateAddWebSearchFormProps {
    setIsAddWebSearch: React.Dispatch<React.SetStateAction<boolean>>;
    candidateId: number;
    setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
    loading: boolean;
    setError: React.Dispatch<React.SetStateAction<string | null>>;
    editorName: string;
}

const CandidateAddWebSearchForm: React.FC<CandidateAddWebSearchFormProps> = ({ setIsAddWebSearch, setRefresh, setError, editorName, candidateId }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const handleAddWebSearch = async () => {
        const candidateWebSearchPayload = {
            custom_fields: {
                web_search: [{
                    webpages: [
                        {
                            engine: form.getFieldValue("engine"),
                            url: form.getFieldValue("url"),
                            name: form.getFieldValue("name"),
                            snippet: form.getFieldValue("snippet"),
                            site: form.getFieldValue("site"),
                            thumbnail_url: form.getFieldValue("thumbnail_url"),
                            // date_added: form.getFieldValue("date_added"),
                            date_added: new Date().toISOString()
                            .split("T")[0],
                            edited_by: editorName, 
                            modified_date: new Date(), 
                            is_edited: false
                        }
                    ]
                }],
            }, candidate: candidateId
        };
        console.log("WebSearch Payload:", candidateWebSearchPayload);
        try {
            const data = await editCandidate(candidateWebSearchPayload);
            setRefresh(true);
            setIsAddWebSearch(false);
        } catch (err) {
            setError("Failed to update candidate description");
        } finally {
            // setRefresh(false);
            dispatch(creditsRefreshChanger());
        }
    };

    const onFinish = (values: any) => {
        console.log("Form Submitted: ", values);
        handleAddWebSearch();
        setIsAddWebSearch(false);
    };

    return (
        // <Card title={
        //     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        //         <span>Search Engine Data Form</span>
        //         <img
        //             src={xIcon}
        //             alt=""
        //             style={{
        //                 display: "inline-flex",
        //                 alignItems: "center",
        //                 justifyContent: "center",
        //                 width: "35px",
        //                 height: "35px",
        //                 borderRadius: "50%",
        //                 backgroundColor: "#E4E7EC",
        //                 cursor: "pointer",
        //                 padding: "8px",
        //             }}
        //             onClick={() => setIsAddWebSearch(false)}
        //         />
        //     </div>
        // }
        //     style={{ maxWidth: "100%", margin: "auto" }}>
        <Card title="Search Engine Data Form" style={{ maxWidth: "100%", margin: "auto" }}>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            // initialValues={{
            //     engine: "WebSearchEngine",
            //     url: "https://www.linkedin.com/posts/prince-rabadiya_i-am-honored-to-receive-the-excellent-activity-7245462477780471808-YPpb",
            //     name: "Prince Rabadiya on LinkedIn: I am honored to receive the Excellent ...",
            //     snippet: "Sep 27, 2024 ... Jaimin Solanki. Senior software engineer at Cephei Infotech | 3x AWS certified ... Engineering #Innovation #ScaleTech #NewBeginnings ...",
            //     site: "linkedin.com",
            //     thumbnail_url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGJNPvA8BKkq7-gmfR4LkWMowsicpvHNatoPjXLWylW47gxteWBIdAP04&s",
            // }}
            >
                <Form.Item label="Engine" name="engine" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="URL" name="url" rules={[{ required: true, type: "url", message: "Please enter a valid URL" }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="Name" name="name" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="Snippet" name="snippet">
                    <Input.TextArea rows={3} />
                </Form.Item>

                <Form.Item label="Site" name="site" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="Thumbnail URL" name="thumbnail_url" rules={[{ required: true, type: "url", message: "Please enter a valid URL" }]}>
                    <Input />
                </Form.Item>

                <Form.Item>
                    <Button className="relative font-semibold text-sm text-white py-2 px-3 bg-[#845dda] border border-[#7F56D9] flex gap-1 rounded-lg group" htmlType="submit">Submit</Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default CandidateAddWebSearchForm;
